import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Helpers } from '@store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { CompanyApi, UserRegistrationApi } from '@vi-iot/client';

import { UsersActions } from './users.actions';

@Injectable()
export class UsersListEffects {
  listUsersSearchResult$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(UsersActions.listUsersSearchResult),
      switchMap((action) =>
        this.userRegistrationApi
          .listUsers(
            action.searchParams.loginId,
            action.searchParams.firstName,
            action.searchParams.familyName,
            action.searchParams.city,
            action.searchParams.street,
            action.searchParams.postalCode,
            action.searchParams.limit,
            action.searchParams.offset
          )
          .pipe(
            map((data) => UsersActions.listUsersSearchResultSuccess({ payload: data })),
            catchError(() => of(UsersActions.listUsersSearchResultError()))
          )
      )
    );
  });

  listCompanyUsersSearchResult$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(UsersActions.listCompanyUsersSearchResult),
      switchMap((action) =>
        this.companyApi.getCompanyClients(action.companyNumber).pipe(
          map((response) => {
            const data = { users: [] };
            data.users = response.map((item) => Helpers.mapCompanyClientUserToUser(item));

            return UsersActions.listCompanyUsersSearchResultSuccess({ payload: data });
          }),
          catchError(() => of(UsersActions.listCompanyUsersSearchResultError()))
        )
      )
    );
  });

  listUsersSearchFetchMore$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(UsersActions.listUsersSearchFetchMore),
      switchMap((action) =>
        this.userRegistrationApi
          .listUsers(
            action.searchParams.loginId,
            action.searchParams.firstName,
            action.searchParams.familyName,
            action.searchParams.city,
            action.searchParams.street,
            action.searchParams.postalCode,
            action.searchParams.limit,
            action.searchParams.offset
          )
          .pipe(
            map((data) => UsersActions.listUsersSearchFetchMoreSuccess({ payload: data })),
            catchError(() => of(UsersActions.listUsersSearchFetchMoreError()))
          )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private userRegistrationApi: UserRegistrationApi,
    private companyApi: CompanyApi
  ) {}
}
